const MOCK_SESSION_KEY = 'mock_logged_in';

export const mockSession = {
  setLoggedIn: () => sessionStorage.setItem(MOCK_SESSION_KEY, 'true'),
  isLoggedIn: () => sessionStorage.getItem(MOCK_SESSION_KEY) === 'true',
  logout: () => sessionStorage.removeItem(MOCK_SESSION_KEY),
};
